import { render, staticRenderFns } from "./EventFormSettingContent.vue?vue&type=template&id=5b07e485"
import script from "./EventFormSettingContent.vue?vue&type=script&lang=js"
export * from "./EventFormSettingContent.vue?vue&type=script&lang=js"
import style0 from "./EventFormSettingContent.vue?vue&type=style&index=0&id=5b07e485&prod&lang=css"
import style1 from "./EventFormSettingContent.vue?vue&type=style&index=1&id=5b07e485&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports